import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getMeetSessionByMeetIdData from './GetMeetSessionByMeetIdData';

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  meetId: Constants.DEFAULT_ID,
  dataAsOptionsWithNames: []
};

const MeetSessionData = {
  getMeetSessionByMeetIdData,
  INITIAL_STATE
};

export default MeetSessionData;